import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

// Configure Echo for Soketi (self-hosted Pusher)
window.Echo = new Echo({
    broadcaster: 'pusher',
    key: import.meta.env.VITE_PUSHER_APP_KEY || 'intellicampus-key',
    cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER || 'mt1',
    wsHost: import.meta.env.VITE_PUSHER_HOST || window.location.hostname,
    wsPort: import.meta.env.VITE_PUSHER_PORT || 6001,
    wssPort: import.meta.env.VITE_PUSHER_PORT || 6001,
    forceTLS: (import.meta.env.VITE_PUSHER_SCHEME || 'http') === 'https',
    encrypted: (import.meta.env.VITE_PUSHER_SCHEME || 'http') === 'https',
    disableStats: true,
    enabledTransports: ['ws', 'wss'],
    authEndpoint: '/broadcasting/auth',
    auth: {
        headers: {
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
        }
    }
});

// Log connection status
window.Echo.connector.pusher.connection.bind('connected', () => {
    console.log('✅ Laravel Echo connected');
});

window.Echo.connector.pusher.connection.bind('error', (error) => {
    console.error('❌ Laravel Echo error:', error);
});

window.Echo.connector.pusher.connection.bind('disconnected', () => {
    console.warn('⚠️ Laravel Echo disconnected');
});
